import { memo } from 'react';
import { Stack, Spinner, Text } from '@chakra-ui/react';

const AnalysisInProgress = memo(() => {
  return (
    <Stack
      h="100%"
      w="100%"
      gap="24px"
      justifyContent="center"
      alignItems="center"
      mt="60px"
      p="32px"
      bg="white"
    >
      <Spinner size="xl" color="primary.700" borderWidth="3px" />
      <Stack gap="4" textAlign="center" maxW="600px">
        <Text fontSize="xl" fontWeight="semibold" color="neutrals.900">
          Analysis in Progress
        </Text>
        <Text color="neutrals.600">
          We're currently analyzing the interview recording and transcript. This process typically
          takes a few minutes. You'll be able to view the detailed analysis, including key insights,
          skill matches, and follow-up items once it's complete.
        </Text>
        <Text fontSize="sm" color="neutrals.500">
          Please check back in a few minutes or refresh the page.
        </Text>
      </Stack>
    </Stack>
  );
});

AnalysisInProgress.displayName = 'AnalysisInProgress';

export default AnalysisInProgress;
